/* Keep v2 stamping fee quantities tied to their parent items; retain the existing drawer UI. */
(function () {
  'use strict';
  var source = document.currentScript && document.currentScript.src;
  var baseSource = source && source.replace(/cart-drawer\.js(?=\?|$)/, 'cart-drawer-base-20260907.js');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var latest = null, queue = Promise.resolve(), checkoutBusy = false, checkoutError = '';
  var lockedInputs = new Map();
  function read() { return request('cart.js'); }
  function request(path, body) {
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); },15000);
    return fetch(ROOT + path, {method:body ? 'POST' : 'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body ? JSON.stringify(body) : undefined,signal:controller.signal}).then(function (res) {
      return res.json().then(function (data) { if (!res.ok) throw new Error(data.description || 'Unable to update the cart.'); return data; });
    }).finally(function () { clearTimeout(timeout); });
  }
  function p(item) { return item.properties || {}; }
  function isFee(item) { return p(item)._is_personalization_fee === 'true'; }
  function controlled(item) { return p(item)._emboss_pricing_version === '2'; }
  var EMBROIDERY_FEE = 55699949584552;
  function embroideryFee(item) { return Number(item.variant_id || item.id) === EMBROIDERY_FEE; }
  function embroideryParent(item) { return !embroideryFee(item) && !!(p(item)['Embroidery line 1'] || p(item)['Embroidery line 2']); }
  function hasControlled(cart) { return cart && (cart.items || []).some(function (item) { return controlled(item) || embroideryFee(item) || embroideryParent(item); }); }
  function plan(cart) {
    var items = cart.items || [], updates = {}, additions = [];
    var parents = items.filter(function (i) { return controlled(i) && !isFee(i) && p(i).Personalization === 'Yes'; });
    parents.forEach(function (parent) {
      var props = p(parent), units = Number(props._emboss_units_per_item), total = units * parent.quantity;
      var maximum = Number(props._emboss_volume_count), id = Number(props._emboss_fee_variant);
      if (!Number.isSafeInteger(units) || units < 1 || !Number.isSafeInteger(total) || total < 1 || !id || (maximum > 0 && units > maximum)) throw new Error('Please remove and personalize this item again to confirm its volume selection.');
      var fees = items.filter(function (i) { return controlled(i) && isFee(i) && p(i)._emboss_group === props._emboss_group; });
      var match = fees.find(function (i) { return Number(i.variant_id || i.id) === id; });
      fees.forEach(function (i) { var quantity = i === match ? total : 0; if (i.quantity !== quantity) updates[i.key] = quantity; });
      if (!match) additions.push({id:id,quantity:total,properties:{'For item':parent.product_title || parent.title,Name:props.Name,'Volumes to stamp':props['Volumes to stamp'],_is_personalization_fee:'true',_emboss_group:props._emboss_group,_for_product_id:String(parent.product_id || ''),_for_variant_id:String(parent.variant_id || parent.id),_emboss_name:props.Name,_emboss_language:props.Language,_emboss_foil:props.Foil,_emboss_pricing_version:'2',_emboss_units_per_item:String(units)}});
    });
    items.filter(function (i) { return controlled(i) && isFee(i); }).forEach(function (i) {
      if (!parents.some(function (parent) { return p(parent)._emboss_group === p(i)._emboss_group; })) updates[i.key] = 0;
    });
    var embroideryParents = items.filter(embroideryParent), claimed = new Set();
    embroideryParents.forEach(function (parent) {
      var props = p(parent), letters = String(props['Embroidery line 1'] || '').concat(String(props['Embroidery line 2'] || '')).replace(/\s/g,'').length;
      var units = letters * parent.quantity, identity = props._embroidery_group || parent.key;
      if (!letters || !identity || !Number.isSafeInteger(units) || units < 1) throw new Error('Please remove and personalize this item again to confirm its lettering.');
      var fees = items.filter(function (item) { return embroideryFee(item) && p(item)._embroidery_parent === identity; });
      var match = fees[0];
      fees.forEach(function (fee) { claimed.add(fee.key); var quantity = fee === match ? units : 0; if (fee.quantity !== quantity) updates[fee.key] = quantity; });
      if (!match) additions.push({id:EMBROIDERY_FEE,quantity:units,properties:{'For':parent.product_title || parent.title,_Spec:letters+' letters per item',_is_personalization_fee:'true',_embroidery_parent:identity,_embroidery_letters_per_item:String(letters),_for_product_id:String(parent.product_id || ''),_for_variant_id:String(parent.variant_id || parent.id)}});
    });
    items.filter(embroideryFee).forEach(function (fee) { if (!claimed.has(fee.key)) updates[fee.key] = 0; });
    return {updates:updates,additions:additions};
  }
  function lockFeeRows(cart) {
    if (!cart) return;
    var fees = new Set((cart.items || []).filter(function (i) { return controlled(i) && isFee(i) || embroideryFee(i); }).map(function (i) { return i.key; }));
    document.querySelectorAll('.mc-item[data-item-key], .cd-item[data-key]').forEach(function (row) {
      var key = row.dataset.itemKey || row.dataset.key;
      if (!fees.has(key)) return;
      row.querySelectorAll('[data-qty-change], [data-cd-qty]').forEach(function (button) { button.disabled = true; button.setAttribute('aria-label','Fee quantity follows the personalized item'); });
      row.querySelectorAll('input[data-key]').forEach(function (input) { input.readOnly = true; });
      row.querySelectorAll('[data-remove], [data-cd-remove]').forEach(function (button) { button.disabled = true; button.textContent = 'Linked to personalized item'; });
    });
  }
  function showError(message) {
    var hosts = document.querySelectorAll('.mc-page, [data-cd-foot]');
    hosts.forEach(function (host) {
      var banner = host.querySelector('[data-emboss-cart-error]');
      if (!banner && message) { banner = document.createElement('p'); banner.dataset.embossCartError = ''; banner.setAttribute('role','alert'); host.insertBefore(banner,host.firstChild); }
      if (banner) { banner.textContent = message || ''; banner.hidden = !message; }
    });
  }
  function normalize(cart, attempt) {
    var changes = plan(cart);
    if (!Object.keys(changes.updates).length && !changes.additions.length) return Promise.resolve(cart);
    if (attempt >= 4) return Promise.reject(new Error('Your cart changed while personalization was updating. Please try checkout again.'));
    return (Object.keys(changes.updates).length ? request('cart/update.js',{updates:changes.updates}) : Promise.resolve(cart)).then(function () {
      return read().then(function (fresh) { var nextChanges = plan(fresh); return nextChanges.additions.length ? request('cart/add.js',{items:nextChanges.additions}) : null; });
    }).then(read).then(function (next) { return normalize(next,attempt + 1); });
  }
  function reconcile() {
    var run = queue.catch(function () {}).then(read).then(function (cart) {
      var before = JSON.stringify((cart.items || []).map(function (i) { return [i.key,i.quantity]; }));
      return normalize(cart,0).then(function (next) {
        latest = next; showError('');
        var after = JSON.stringify((next.items || []).map(function (i) { return [i.key,i.quantity]; }));
        if (before !== after) document.dispatchEvent(new CustomEvent('cart:change',{detail:{cart:next,item_count:next.item_count,itemCount:next.item_count,reason:'stamping-fee-sync',source:'jsq-emboss-pricing'}}));
        lockFeeRows(next); return next;
      });
    });
    queue = run.catch(function (err) { showError(err.message); });
    return run;
  }
  window.JSQEmbossCart = {plan:plan,reconcile:reconcile};
  document.addEventListener('cart:change',function (event) {
    var detail = event.detail || {};
    if (detail.reason === 'change' || detail.reason === 'page-change') { checkoutError = ''; showError(''); }
    if (detail.cart) { latest = detail.cart; queueMicrotask(function () { lockFeeRows(latest); }); }
    if (detail.source !== 'jsq-emboss-pricing') {
      /* EMBQTY 2026-10-12: never reconcile while a cart quantity box is being edited; run once it loses focus. */
      var active = document.activeElement;
      if (active && active.matches && active.matches('.mc-page input[data-key]')) { reconcilePending = true; return; }
      reconcile().catch(function () {});
    }
  });
  var reconcilePending = false;
  document.addEventListener('focusout',function (event) {
    if (!reconcilePending || !event.target.matches || !event.target.matches('.mc-page input[data-key]')) return;
    setTimeout(function () {
      var active = document.activeElement;
      if (active && active.matches && active.matches('.mc-page input[data-key]')) return;
      reconcilePending = false;
      reconcile().catch(function () {});
    },0);
  });
  document.addEventListener('cart:page:rendered',function () { lockFeeRows(latest); if (checkoutBusy) lockQuantities(); if (checkoutError) showError(checkoutError); });
  document.addEventListener('click',function (event) {
    var button = event.target.closest('[data-qty-change], [data-cd-qty], [data-remove], [data-cd-remove]');
    if (!button) return;
    if (checkoutBusy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!latest) return;
    var row = button.closest('[data-item-key], .cd-item[data-key]');
    var key = row && (row.dataset.itemKey || row.dataset.key);
    if ((latest.items || []).some(function (i) { return i.key === key && (controlled(i) && isFee(i) || embroideryFee(i)); })) { event.preventDefault(); event.stopImmediatePropagation(); }
  },true);
  function metadata(button) {
    var form = button && (button.form || button.closest('form')), body = {attributes:{}};
    if (form) {
      new FormData(form).forEach(function (value,key) {
        if (typeof value !== 'string') return;
        if (key === 'note') body.note = value;
        var match = key.match(/^attributes\[([^\]]+)\]$/); if (match) body.attributes[match[1]] = value;
      });
    } else {
      var drawer = button && button.closest('[data-cd-drawer]');
      if (drawer) {
        var gift = drawer.querySelector('[data-cd-gift]'), msg = drawer.querySelector('[data-cd-gift-msg]'), note = drawer.querySelector('[data-cd-note]');
        body.attributes.Gift = gift && gift.checked ? 'Yes — include printed message' : '';
        body.attributes['Gift message'] = gift && gift.checked && msg ? msg.value.trim() : '';
        if (note) body.note = note.value.trim();
      }
    }
    return body;
  }
  function quantityInputs(form) {
    return form ? Array.from(form.elements).filter(function (input) { return !input.disabled && /^updates(?:\[.*\])?$/.test(input.name); }) : [];
  }
  function lockQuantities() {
    document.querySelectorAll('form input[name^="updates"]').forEach(function (input) {
      if (!lockedInputs.has(input)) lockedInputs.set(input,input.readOnly);
      input.readOnly = true;
    });
  }
  function unlockQuantities() {
    lockedInputs.forEach(function (readOnly,input) { input.readOnly = readOnly; });
    lockedInputs.clear();
  }
  function lineIdentity(item) {
    return JSON.stringify([item.variant_id || item.id,Object.entries(item.properties || {}).sort(),item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || null]);
  }
  function syncQuantities(cart, quantities) {
    var indexed = 0;
    var changes = quantities.map(function (entry) {
      var match = entry.name.match(/^updates\[([^\]]+)\]$/), item;
      if (match) {
        item = (cart.items || []).find(function (item) { return item.key === match[1]; });
        if (!item) {
          var variants = (cart.items || []).filter(function (item) { return String(item.variant_id || item.id) === match[1]; });
          if (variants.length === 1) item = variants[0];
        }
      } else item = (cart.items || [])[indexed++];
      if (!item && entry.quantity !== 0) throw new Error('Please refresh your cart before checking out.');
      return item && item.quantity !== entry.quantity ? {key:item.key,identity:lineIdentity(item),quantity:entry.quantity} : null;
    }).filter(Boolean);
    return changes.reduce(function (pending,change) {
      return pending.then(function (current) {
        var matches = (current.items || []).filter(function (item) { return lineIdentity(item) === change.identity; });
        if (matches.length !== 1) throw new Error('Please refresh your cart before checking out.');
        return request('cart/change.js',{id:matches[0].key,quantity:change.quantity}).then(function (next) {
          var updated = (next.items || []).filter(function (item) { return lineIdentity(item) === change.identity; });
          var item = updated.length === 1 ? updated[0] : null;
          if ((item ? item.quantity : 0) !== change.quantity) throw new Error('Please check your cart quantity and try again.');
          document.dispatchEvent(new CustomEvent('cart:change',{detail:{cart:next,source:'jsq-checkout',reason:'checkout-quantity'}}));
          return next;
        });
      });
    },Promise.resolve(cart));
  }
  function checkout(event,button) {
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutBusy || button && button.disabled) return;
    var form = button && (button.form || button.closest('form'));
    var validationForm = form || document.getElementById('mc-form');
    if (validationForm && !validationForm.reportValidity()) return;
    var inputs = quantityInputs(form), invalid = inputs.find(function (input) { return input.value.trim() === '' || !Number.isSafeInteger(Number(input.value)) || Number(input.value) < 0; });
    if (invalid) { invalid.focus(); showError('Please check your cart quantity and try again.'); return; }
    var quantities = form && form.id === 'mc-form' && window.JSQModernCartPending ? [] : inputs.map(function (input) { return {name:input.name,quantity:Number(input.value)}; });
    var body = metadata(button);
    checkoutBusy = true; checkoutError = ''; lockQuantities();
    if (button) button.setAttribute('aria-busy','true');
    Promise.resolve().then(function () {
      return Promise.all([window.JSQModernCartPending ? window.JSQModernCartPending(true) : null, window.JSQDrawerCartPending ? window.JSQDrawerCartPending(true) : null]);
    }).then(function () {
      if (window.JSQCartQuantityErrors && window.JSQCartQuantityErrors.size) throw window.JSQCartQuantityErrors.values().next().value;
      return read();
    }).then(function (cart) { return syncQuantities(cart,quantities); }).then(reconcile).then(function (cart) {
      if (!cart.items || !cart.items.length) throw new Error('Add an item to your cart before checkout.');
      return request('cart/update.js',body);
    }).then(function () {
      window.location.href = ROOT + 'checkout';
    }).catch(function (err) {
      checkoutBusy = false; unlockQuantities();
      if (button) button.removeAttribute('aria-busy');
      checkoutError = err.name === 'AbortError' ? 'Please refresh your cart before checking out.' : err.message || 'Please refresh your cart before checking out.';
      showError(checkoutError);
    });
  }
  document.addEventListener('click',function (event) {
    var button = event.target.closest('[data-cd-checkout], .mc-checkout, button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (button) checkout(event,button);
  },true);
  document.addEventListener('submit',function (event) {
    if (!(event.target instanceof HTMLFormElement) || !/\/cart\/?(?:\?|$)/.test(event.target.getAttribute('action') || '')) return;
    var button = event.submitter || event.target.querySelector('[name="checkout"]');
    if (button && button.name === 'checkout') checkout(event,button);
  },true);
  function start() { read().then(function (cart) { latest = cart; lockFeeRows(cart); if (hasControlled(cart)) reconcile().catch(function () {}); }).catch(function (err) { console.error('[stamping cart]',err); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  if (baseSource && baseSource !== source && !window.__jsqDrawerBaseLoaded) {
    window.__jsqDrawerBaseLoaded = true;
    var base = document.createElement('script'); base.src = baseSource + (baseSource.indexOf('?') === -1 ? '?' : '&') + 'ui_revision=cart-validation-20261012'; base.defer = true;
    base.onerror = function () { console.error('[cart] Drawer failed to load; the full cart remains available.'); };
    document.head.appendChild(base);
  }
})();
